/**
 * Transforms a raw percentile for display across Overview tables and figures.
 * - Rounds to nearest whole number
 * - 0 (or values rounding to 0) → 1 (display as 1st percentile)
 * - 100 (or values rounding to 100) → 99 (display as 99th percentile)
 */
export function displayPercentile(raw: number | null | undefined): number | null {
  if (raw == null || !Number.isFinite(raw)) return null;
  const scaled = raw <= 1 ? raw * 100 : raw;
  const rounded = Math.round(scaled);
  if (rounded <= 0) return 1;
  if (rounded >= 100) return 99;
  return rounded;
}
